import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import NotFound from '../views/NotFound';
import { routes } from './ROUTES';

Vue.use(Router);
Vue.use(Meta);

const resolveRoute = (route) => {
  const result = {
    ...route,
    props: true,
    children: route.children
      ? Object.values(route.children)
        .map(children => resolveRoute(children))
      : undefined,
  };
  if (route.template) {
    result.component = () => import(`@/views/${ route.template }.vue`);
  }
  if (route.components) {
    result.components = Object.entries(route.components).reduce((acc, ar) => {
      const [key, value] = ar;
      acc[key] = () => import(`@/views/${ value }.vue`);
      return acc;
    }, {});
  }
  return result;
};

export function createRouter() {
  return new Router({
    mode: 'history',
    routes: [
      ...Object.values(routes).map(route => resolveRoute(route)),
      {
        path: '*',
        name: '404',
        component: NotFound,
        meta: {
          title: 'Not found',
        },
      },
    ],
  });
}
